import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import ProfileImage from "../../Components/ProfileImage";
import { RiderModel } from "../../Api/Models/rider.model";
import { riderService } from "../../Api/Services/RiderService";
import { useLoading } from "../../Context/LoadingProvider";

import TalabatLogo from "../../Assets/gfx/talabat.svg";
import UserNavigation from "../UserNavigation";
import { LongArrowRightIcon } from "../../Components/Icons/LongArrowRightIcon";
import { TextDeleteIcon } from "../../Components/Icons/TextDeleteIcon";
import { HomeIcon } from "../../Components/Icons/HomeIcon";


interface RiderSearchProps {}

const RiderSearch: React.FunctionComponent<RiderSearchProps> = () => {
  const { t } = useTranslation();
  const { startLoading, finnishLoading } = useLoading();
  const navigate = useNavigate();

  const [riderId, setRiderId] = useState("");
  const [riders, setRiders] = useState<RiderModel[]>([]);

  const addToEndOfRiderId = (x: string | number) => {
    setRiderId(riderId + x.toString());
  };

  const removeLastCharacterFromRiderId = (/*x: string | number*/) => {
    setRiderId(riderId.substring(0, Math.max(riderId.length - 1, 0)));
  };

  const [showInvalidRiderId, setShowInvalidRiderId] = useState<boolean>(false);

  /*
  const clearRiderId = (x: string | number) => {
    setRiderId("");
  };
  */


  const fetchRiders = (e: React.FormEvent) => {
    e.preventDefault();
    startLoading("search-riders");
    riderService
      .search(riderId)
      .then((ridersResult) => {
        setRiders(ridersResult);
        if (ridersResult.length === 1) {
          navigate(`/rider/${ridersResult[0].riderId}/profile`);
        } else {
          setShowInvalidRiderId(true);
        }
      })
      .finally(() => {
        finnishLoading("search-riders");
      });
  };

  const getNumpadButtons = () => {
    const numpadButtons = [];
    for (let i = 1; i <= 9; i++) {
      numpadButtons.push({
        content: i,
        onClick: addToEndOfRiderId,
        extraClasses: "",
      });
    }
    
    //numpadButtons.push({
    //  content: '<img src="' + arrowLeft + '" />',
    //  onClick: removeLastCharacterFromRiderId,
    //  extraClasses: "back",
    //});
//
    //numpadButtons.push({
    //  content: 0,
    //  onClick: addToEndOfRiderId,
    //  extraClasses: "",
    //});
//
    //numpadButtons.push({
    //  content: '<img src="' + timesCircle + '" />',
    //  onClick: clearRiderId,
    //  extraClasses: "clear",
    //});
    return numpadButtons;
  };

  return (
    <div className="view-container view-container--stretch background">
      <div className="view-content h-full flex flex-col justify-between">
        <div>
          <div className="navigationbar mb-6">
            <div className="navigationbar__left">
              <Link to="/menu" className="navigationbar__button">
                <HomeIcon />
              </Link>
            </div>
            <div className="navigationbar__center">
              <img src={TalabatLogo} width="95" height="20" style={{minWidth: '95px'}} alt="Talabat" />
            </div>
            <div className="navigationbar__right">
              <UserNavigation />
            </div>
          </div>
        </div>

        <div className="inner-view-container background-white top-border-radius">
          <div className="inner-view-content">
            <div className="heading text-center mb-4">{t("Rider Search")}</div>
            <form className="flex flex-col items-center" onSubmit={fetchRiders}>
            
              <div className="relative mb-2 w-full">
                <input
                  className={`input-field input-field--line text-center ${showInvalidRiderId ? "input-field--error" : ""}`}
                  type="number"
                  step={1}
                  min={0}
                  value={riderId}
                  placeholder="Rider ID"
                  onChange={(e) => {
                    setShowInvalidRiderId(false);
                    setRiderId(e.target.value);
                  }}
                />

                <div className="input-icon--right" onClick={(e) => {
                    removeLastCharacterFromRiderId();
                  }}>
                  <TextDeleteIcon  />
                </div>

                {showInvalidRiderId && (
                <div className="input-field-error-bubble">
                  {t("Invalid Rider ID")}
                </div>
                )}
              </div>
              

              <div className="numpad mb-4 w-full">
                {getNumpadButtons().map((buttonData) => (
                  <div
                    className="numpad__button__container"
                    key={buttonData.content}
                  >
                    <div
                      className={"numpad__button " + buttonData.extraClasses}
                      onClick={() => buttonData.onClick(buttonData.content)}
                      dangerouslySetInnerHTML={{
                        __html: buttonData.content.toString(),
                      }}
                    ></div>
                  </div>
                ))}

                  <div></div>

                  <div className="numpad__button__container">
                    <div
                      className="numpad__button"
                      onClick={() => addToEndOfRiderId("0")}
                      
                    >0</div>
                  </div>
                
              </div>

              <div className="w-full mb-6">
                <button type="submit" className="button w-full">
                  {t("Search")}
                  <LongArrowRightIcon/>
                </button>
              </div>
            </form>

            <div className="relative">
              {riders.map((rider) => (      
                <Link
                  className="small-border-card mb-4"
                  to={`/rider/${rider.riderId}/profile`}
                  state={{ riderModel: rider }}
                  key={rider.riderId}
                >
                  <ProfileImage imageUrl={rider.image} riderId={rider.riderId} />
                </Link>
              ))}
            </div>
          </div>

         

        </div>
      </div>
    </div>
  );
};

export default RiderSearch;
